module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_3000_5000.bcf3015f.png";